/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotobottom3Inputs */

const en_aiflowphotobottom3 = /** @type {(inputs: Aiflowphotobottom3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom`)
};

const de_aiflowphotobottom3 = /** @type {(inputs: Aiflowphotobottom3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unten`)
};

/**
* | output |
* | --- |
* | "Bottom" |
*
* @param {Aiflowphotobottom3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotobottom3 = /** @type {((inputs?: Aiflowphotobottom3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotobottom3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotobottom3(inputs)
	return de_aiflowphotobottom3(inputs)
});
export { aiflowphotobottom3 as "aiFlowPhotoBottom" }